import { guideItems } from '@/mocks/guide';
import SectionHeading from './SectionHeading';

export default function GuideSection() {
  return (
    <section id="guide" className="w-full bg-background-100 py-14 md:py-20">
      <div className="mx-auto w-full max-w-[1180px] px-4 md:px-6">
        <SectionHeading
          eyebrow="07 / 观影指南"
          title="观影前，先了解这几件事"
          desc="除了剧情与演员，了解影片的分级定位、时代背景与观看方式，能帮你更清楚地判断它是否适合自己。"
        />

        <div className="mt-8 grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
          {guideItems.map((item) => (
            <div
              key={item.title}
              className="flex flex-col gap-3 rounded-lg border border-background-200 bg-background-50 p-5 md:p-6"
            >
              <span className="flex items-center justify-center w-11 h-11 rounded-lg bg-accent-100 text-accent-800">
                <i className={`${item.icon} text-xl`} />
              </span>
              <h3 className="font-heading text-base font-semibold text-foreground-950">{item.title}</h3>
              <p className="text-sm leading-relaxed text-foreground-600">{item.content}</p>
            </div>
          ))}

          <div className="flex flex-col justify-center gap-3 rounded-lg border border-primary-200 bg-primary-50 p-5 md:p-6">
            <span className="flex items-center justify-center w-11 h-11 rounded-lg bg-primary-500 text-background-50">
              <i className="ri-information-line text-xl" />
            </span>
            <h3 className="font-heading text-base font-semibold text-primary-900">关于本页内容</h3>
            <p className="text-sm leading-relaxed text-primary-800">
              本页为影视资料整理，内容参考公开资料编写，仅作观影前的背景参考，不提供任何影片播放或下载服务。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}